<div
  covDragDropFiles
  [allowedFileTypes]="allowedFileExtensions()"
  class="w-100 d-flex justify-content-center drop-space"
  (filesDropped)="onFilesDropped($event)"
>
  <div class="d-flex flex-column gap-2 m-4">
    <cov-icon class="upload-icon" [iconName]="IconName.UPLOAD" />
    <h3>{{ 'inquiries.sideDrawer.fileAttachments.dropFilesHere'|transloco }}</h3>
    <div class="additional">
      @if (maxFileSize()) {
        <p>
          {{ 'inquiries.sideDrawer.fileAttachments.maximumFileSize'|transloco:{maxFileSize: maxFileSize()} }}
        </p>
      }
      @if (allowedFormatsString(); as formats) {
        <p>
          {{ 'inquiries.sideDrawer.fileAttachments.allowedFormats'|transloco:{allowedFormats: formats} }}
        </p>
      }
    </div>
  </div>
</div>
